import { create } from "zustand/react"

type LeadStore = {
	status: boolean
	setStatus: (status: boolean) => void
	leadId: string
	setLeadId: (leadId: string) => void
	params: any
	setParams: (val: any) => void
	metaData: any
	setMetaData: (val: any) => void
}

export const useLeadStore = create<LeadStore>()(set => ({
	status: true,
	setStatus: status => set(() => ({ status })),
	leadId: "",
	setLeadId: leadId => set(() => ({ leadId })),
	params: null,
	setParams: params => set(() => ({ params })),
	metaData: null,
	setMetaData: metaData => set(() => ({ metaData })),
}))
